export default "__VITE_ASSET__qEsVMBde__"